const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'separationList',
		'separationList'
	],

	config: {
		hideHeadContainingOneSingleElement: false,
	},

	model: {
		entityParent: {}, 			// entityParent cache
		ninjaModule: '',            // actual ninjaModule (e.g., news)
		ninjaModuleConfig: {},      // actual ninjaModuleConfig defined by web-projects clientAppConfig (e.g., appConfig.ninjaModules.news)

		state: {						// cache used to store the actual entity-state
			// entityID: null,			// actual records entityID
			entityPartsByLangCode: {	// actual records parts
				// 'de-at': {
				// 	entityPartID: null,	// actual records parts entityPartID
				// 	routeID: null,		// actual records parts routeID
				// 	templateID: null,	// actual records parts routes templateID (layout). this is needed for routeContentTrees to prevent other parentLayouts than this one to be shown to users without special permissions.
				// 	title: null,		// actual records parts title
				// }
			},
		},
	},

	methods: {
		initState(){
			const {
				entityPrimaryKeyName,
				entityPartPrimaryKeyName,
				entityPartRouteIDFieldName,
			} = (this.model.ninjaModuleConfig.db || {})


			const entityParent = this.model.entityParent = this.getResourceRegisterContent('entityParent') || {}
			const entityAttributes = entityParent.attributes || {}
			const entityPartsByLangCode = entityAttributes.entityPartsByLangCode || {}
			const entityPrimaryKey = entityAttributes[entityParent.primaryKey || entityPrimaryKeyName || 'id']

			const state = this.model.state = {
				entityID: entityPrimaryKey,
				entityPartsByLangCode: {},
			}

			this.config.availableSeparators = this.config.availableSeparators || {}
			const separators = this.config.availableSeparators.list = this.config.availableSeparators.list || {}
			const langCodes = Object.keys({
				...separators,
				...entityPartsByLangCode
			})

			for(const langCode of langCodes){
				const entityPart = entityPartsByLangCode[langCode] || {}
				const entityPartPrimaryKey = entityPart[entityPartPrimaryKeyName || 'id']
				const entityPartRouteID = entityPart[entityPartRouteIDFieldName || 'routeID']
				const entityPartTemplateID = (entityPart.route || {}).templateID
				const entityPartTitle = entityPart.title

				state.entityPartsByLangCode[langCode] = {
					entityPartID: 	entityPartPrimaryKey,
					routeID: 		entityPartRouteID,
					templateID:		entityPartTemplateID,
					title: 			entityPartTitle,
				}
			}
		},

		async updatePartState(langCode, routeID, templateID, entityPartID, title, entityPartStartWithRegisterSecret = null, isSilentUpdate = false){
			if(!langCode){
				return console.error(new ClientError('MISSING_LANGCODE'))
			}
			const byLangCode = this.model.state.entityPartsByLangCode
			const entityPart = byLangCode[langCode] = byLangCode[langCode] || {}
			let refreshElements = false
			let refreshRouteDependents = false

			if(routeID !== undefined){
				refreshElements = refreshElements || entityPart.routeID != routeID
				entityPart.routeID = routeID
			}
			if(templateID !== undefined){
				refreshElements = refreshElements || entityPart.templateID != templateID
				entityPart.templateID = templateID
			}
			if(entityPartID !== undefined){
				refreshElements = refreshElements || entityPart.entityPartID != entityPartID
				entityPart.entityPartID = entityPartID
			}
			if(title !== undefined){
				refreshRouteDependents = refreshRouteDependents || entityPart.title !== title
				entityPart.title = title
			}

			// update state if necessary
			const separator = ((this.config.availableSeparators || {}).list || {})[langCode]
			if(separator){
				separator.resourceID = entityPart.entityPartID
				if(separator.resourceID){
					separator.resourceRegister = {
						entityParent: { // gatekeepers need to know which entityParent to use even if the naming is unfortunate.
							resourceID: separator.resourceID
						},
						entityPartLangCode: langCode,
						entityPartParent: {
							resourceID: separator.resourceID
						},
						routeTreeParent: {
							resourceID: entityPart.routeID,
							templateID: entityPart.templateID,
						},
					}

					if(isSilentUpdate){
						return
					}

					if(refreshElements){
						if(entityPart.routeID){
							await this.updateLanguageConnections()
						}

						await this.refreshElements()
						if(entityPartStartWithRegisterSecret){
							let relationContainer, entityPartTabStrip
							this.find('base_tabStrip_tabStrip', c => {
								relationContainer = c
								return 'break'
							})
							if(relationContainer){{
								entityPartTabStrip = relationContainer.getActiveTabComponent('tabContent')
								if(entityPartTabStrip && entityPartTabStrip.hasClass('base_tabStrip_tabStrip')){
									entityPartTabStrip.focusTab(entityPartStartWithRegisterSecret)
								}
							}}
						}

					} else if(refreshRouteDependents){
						const refreshComponents = []
						this.find('templates_ninja_gatekeeper_route', c => refreshComponents.push(c))
						// this is necessary in case one changes the title without saving within partProperties and then inserts a route via gatekeeper.
						this.find('templates_ninja_partPropertiesForm', c => refreshComponents.push(c))

						for(const c of refreshComponents){
							if((c.model || {}).langCode === langCode){
								await c.refresh()
							}
						}
					}
				}
			}
		},

		getPartState(langCode){
			const state = this.model.state || {}
			return {
				...((state.entityPartsByLangCode || {})[langCode || 'missingLangCode'] || {}),
				entityID: state.entityID,
			}
		},

		extendAvailableSeparators: function(){
			const state = this.model.state || {}

			const {
				entityPrimaryKeyName,
			} = (this.model.ninjaModuleConfig.db || {})

			this.config.availableSeparators = this.config.availableSeparators || {}
			const separators = this.config.availableSeparators.list = this.config.availableSeparators.list || {}

			for(const langCode in separators){
				const {
					entityPartID,
					routeID,
					templateID,
				} = ((state.entityPartsByLangCode || {})[langCode] || {})

				separators[langCode].resourceID = entityPartID
				separators[langCode].resourceRegister = {
					entityParent: { // gatekeepers need to know which entityParent to use even if the naming is unfortunate.
						resourceID: entityPartID
					},
					entityPartLangCode: langCode,
					entityPartParent: {
						resourceID: entityPartID
					},
					routeTreeParent: {
						resourceID: routeID,
						templateID,
					},
				}
				if(!entityPartID){
					separators[langCode].resourceRegister.entityPartParent.dirtyFields = {
						[entityPrimaryKeyName]: state.entityID,
						langCode,
					}
				}
			}

			this.config.availableSeparators.list = {
				common: {
					resourceID: state.entityID,
					resourceRegister: {
						tabOptions: {
							icon: 'fi fi-sliders',
							titleKey: 'separationList.commonTabTitle',
						},
					},
					addElementActionName: 'addCommonTab',
				},
				...separators
			};
		},

		updateTabTitle: function(langCode, title){
			if(langCode){
				const {
					entityID,
				} = this.getPartState(langCode)

				const entityPartsByLangCode = this.model.state.entityPartsByLangCode || {}
				const dirtyTitlesByLangCode = this.model.dirtyTitlesByLangCode = this.model.dirtyTitlesByLangCode || {}

				dirtyTitlesByLangCode[langCode] = title

				let entityPrefix = '';
				if(entityID && this.hasRoleOption('showIDs')){
					entityPrefix = '#' + entityID + ' - ';
				}

				const {
					default: 	defaultLangCode,
					available: 	langs,
				} = utils.language.getConfig(storage)
				const langCodes = Object.keys(langs || {})
				const usedLangCode = storage.langCode
				const firstLangCode = langCodes[0]

				let updateTabTitle = 'Unknown'
				for(const lc of [usedLangCode, defaultLangCode, firstLangCode].concat(langCodes).concat(['fallback'])){
					if(lc && (langs[lc] || lc === 'fallback')) {
						if(dirtyTitlesByLangCode[lc]){
							updateTabTitle = dirtyTitlesByLangCode[lc]
							break;
						} else if((entityPartsByLangCode[lc] || {}).title){
							updateTabTitle = entityPartsByLangCode[lc].title
							break;
						}
					}
				}

				this.furthest('base_tabStrip_tabContent', undefined, function(tabContent){
					var registerSecret = (tabContent.config || {}).registerSecret;
					if(registerSecret !== undefined){
						tabContent.closest('base_tabStrip_tabStrip', function(tabStrip){
							tabStrip.refreshTab(registerSecret, {
								title: entityPrefix + updateTabTitle
							});
						});
					}
				});
			}
		},

		handleError: function(context){
			const apiError = utils.extractBaseError(context.error) || {};

			// routeContentTrees tries to load a componentTree of a route which does not exist yet.
			if(
				(context.component || {}).componentClass === 'templates_routeContentTrees_routeContentTrees' &&
				(context.action || {}).key === 'refreshResources' &&
				apiError.errorCode === 'COMPONENT_TREE_VALIDATION_ERROR_3' &&
				apiError.statusCode === 409
			){
				context.component.closest('base_tabStrip_tabStrip', tabStrip => {
					tabStrip.removeTab('routeProperties')
					tabStrip.removeTab('routeContent')
				})
				context.forceActionSuccess = true;
				return utils.promise.resolve(context);
			} else if(
				(context.component || {}).componentClass === 'templates_ninja_entityController' &&
				(context.action || {}).originalActionKey === 'route.duplicate.byTemplateCodename' &&
				apiError.errorCode === 'CMS_ROUTES_PROVIDER_ERROR_3' &&
				apiError.statusCode === 409
			){
				context.error.errorCode += '_NINJA'
				context.errorUnhandled = true;
				return utils.promise.resolve(context);
			}

			context.errorUnhandled = true;
			return utils.promise.resolve(context);
		},

		onBuild(){
			if(!this.model.ninjaModule){
				this.closest('templates_ninja_controller', controller => {
					const {
						ninjaModule,
						ninjaModuleConfig
					} = controller.getNinjaModuleParams()
					this.model.ninjaModule = ninjaModule
					this.model.ninjaModuleConfig = ninjaModuleConfig
				}, true)

				this.initState()
			}
		},

		ensureRoute(langCode, routeID, caller, isManualCreate = false){
			let propertiesForm, partPropertiesForm
			caller.locate('< templates_ninja_entityController > templates_ninja_propertiesForm', c => propertiesForm = c)
			caller.locate('< base_tabStrip_tabStrip > templates_ninja_partPropertiesForm', c => partPropertiesForm = c)

			if(!propertiesForm){
				return utils.promise.reject(new ClientError('NINJA_ENTITY_CONTROLLER_PROPERTIES_FORM_MISSING'))
			}
			if(!partPropertiesForm){
				return utils.promise.reject(new ClientError('NINJA_ENTITY_CONTROLLER_PART_PROPERTIES_FORM_MISSING'))
			}

			const name = partPropertiesForm.getRouteName(!!routeID) || propertiesForm.getRouteName()
			if(!name){
				if(routeID){
					// name has not changed
					return utils.promise.resolve({
						routeCreationPreventedIntentionally: true
					})
				}

				return utils.promise.reject(new ClientError('NINJA_ENTITY_CONTROLLER_NEW_ROUTE_NAME_MISSING'))
			}

			const ninjaModule = this.model.ninjaModule || ''
			const ninjaModuleConfig = this.model.ninjaModuleConfig || {}
			const ninjaModuleRouteConfig = (ninjaModuleConfig.entityPart || {}).route || {}

			if(!ninjaModuleConfig.turnedOn || !ninjaModuleRouteConfig.turnedOn || !ninjaModule){
				return utils.promise.resolve({
					routeCreationPreventedIntentionally: true
				})
			}

			if(!ninjaModuleRouteConfig.autoCreate && !routeID && !isManualCreate){
				return utils.promise.resolve({
					routeCreationPreventedIntentionally: true
				})
			}

			const routeType = `ninja_${ninjaModule}`

			let attributes = {
				name,
				nameSEO: name,
				type: routeType,
				...(ninjaModuleRouteConfig.createDirtyFields || {}),
				duplicateMeta: {
					target: {
						template: {
							codeName: routeType,
							langCode
						}
					},
					duplicateChildRoutes: 0,
					duplicateRouteContents: 1,
					establishLanguageConnections: 0,
					targetHomeNodeIsValid: 0
				},
			}

			// just update the name if the route has been created before.
			if(routeID){
				attributes = {
					name,
					nameSEO: name,
				}
			}

			return this.performAction(
				this.prepareAction('route.duplicate.byTemplateCodename', routeID, undefined, {
					source: {
						submit: {
							httpMethod: routeID ? 'PATCH' : 'POST',
							data: {
								data: {
									attributes,
								},
							},
						},
					},
				})
			)
				.then(result => utils.promise.resolve(result))
				.fail(error => utils.promise.reject(error))
		},

		async updateLanguageConnections(){
			const ninjaModuleName = this.model.ninjaModule
			const entityID = this.model.state.entityID
			if(!entityID || !ninjaModuleName){
				return
			}

			await this.performAction(
				this.prepareAction('ninja.routeLanguageRelations.setByEntityID', undefined, undefined, {
					source: {
						submit: {
							data: {
								resourceFilters: {
									ninjaModuleName: this.model.ninjaModule,
									entityID,
								},
							},
						},
					},
				})
			)
				.then(result => utils.promise.resolve(result))
				.fail(error => utils.promise.reject(error))
		}
	},

	handlers: [{
		name: 'onDeleteNinjaEntity',
		componentClass: 'templates_ninja_table_table',
		handle: function(callerComponent, primaryKey){
			if(primaryKey && (this.model.state || {}).entityID === primaryKey && callerComponent.model.ninjaModule && this.model.ninjaModule === callerComponent.model.ninjaModule){
				this.furthest('base_tabStrip_tabContent', undefined, tabContent => {
					tabContent.close(true)
				})
			}
		}
	}]
}